import "~/misc/common";
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    console.log('initContractRequestsForm');

    $('#copyPerm').on('click', function () {
      $('#contract_request_cr_addresses_attributes_2_city')
        .val($('#contract_request_cr_addresses_attributes_0_city').val() as string);
      $('#contract_request_cr_addresses_attributes_2_postal_code')
        .val($('#contract_request_cr_addresses_attributes_0_postal_code').val() as string);
      $('#contract_request_cr_addresses_attributes_2_area')
        .val($('#contract_request_cr_addresses_attributes_0_area').val() as string);
      $('#contract_request_cr_addresses_attributes_2_valid_till')
        .val($('#contract_request_cr_addresses_attributes_0_valid_till').val() as string);
    });

    $('#copyTemp').on('click', function () {
      $('#contract_request_cr_addresses_attributes_2_city')
        .val($('#contract_request_cr_addresses_attributes_1_city').val() as string);
      $('#contract_request_cr_addresses_attributes_2_postal_code')
        .val($('#contract_request_cr_addresses_attributes_1_postal_code').val() as string);
      $('#contract_request_cr_addresses_attributes_2_area')
        .val($('#contract_request_cr_addresses_attributes_1_area').val() as string);
      $('#contract_request_cr_addresses_attributes_2_valid_till')
        .val($('#contract_request_cr_addresses_attributes_1_valid_till').val() as string);
    });

    $('#clearTemp').on('click', function () {
      $('#contract_request_cr_addresses_attributes_1_city').val('');
      $('#contract_request_cr_addresses_attributes_1_postal_code').val('');
      $('#contract_request_cr_addresses_attributes_1_area').val('');
      $('#contract_request_cr_addresses_attributes_1_valid_till').val('');
    });
  }
}